module.exports = __webpack_public_path__ + "img/skiing004.134f3c54.jpg";